import React, { createContext, useContext, RefObject, useRef } from "react";

interface FieldRefsContextType {
  fieldRefs: Record<string, RefObject<HTMLInputElement>>;
}

const FieldRefsContext = createContext<FieldRefsContextType | undefined>(
  undefined
);

export const FieldRefsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const fieldRefs = {
    // startDate: useRef<HTMLInputElement>(null),
    // endDate: useRef<HTMLInputElement>(null),
    source: useRef<HTMLInputElement>(null),
    startLocationId: useRef<HTMLInputElement>(null),
    endLocationId: useRef<HTMLInputElement>(null),
    contractType: useRef<HTMLInputElement>(null),
    assetSpecTypeId: useRef<HTMLInputElement>(null),
    assetRatePlanId: useRef<HTMLInputElement>(null),
    advancePaid: useRef<HTMLInputElement>(null),
    assetId: useRef<HTMLInputElement>(null),
    // daily: useRef<HTMLInputElement>(null),
    customerId: useRef<HTMLInputElement>(null),
    addOns: useRef<HTMLInputElement>(null),
    // Claim fields
    "claimRequest.insuranceProviderId": useRef<HTMLInputElement>(null),
    "claimRequest.claimNo": useRef<HTMLInputElement>(null),
    "claimRequest.claimName": useRef<HTMLInputElement>(null),
    "claimRequest.vehicleInformation": useRef<HTMLInputElement>(null),
    "claimRequest.dateOfLoss": useRef<HTMLInputElement>(null),
    "claimRequest.perDayAllowance": useRef<HTMLInputElement>(null),
    "claimRequest.numberOfDayAllowed": useRef<HTMLInputElement>(null),
    "claimRequest.maximumAllowance": useRef<HTMLInputElement>(null),
    "claimRequest.adjusterName": useRef<HTMLInputElement>(null),
    "claimRequest.adjusterPhone": useRef<HTMLInputElement>(null),
    "claimRequest.adjusterEmail": useRef<HTMLInputElement>(null),
    "claimRequest.status": useRef<HTMLInputElement>(null),
    "claimRequest.amountRequested": useRef<HTMLInputElement>(null),
    "claimRequest.amountPaid": useRef<HTMLInputElement>(null),
    "claimRequest.dateClosed": useRef<HTMLInputElement>(null),
    "claimRequest.notes": useRef<HTMLInputElement>(null),
  };

  return (
    <FieldRefsContext.Provider value={{ fieldRefs }}>
      {children}
    </FieldRefsContext.Provider>
  );
};

export const useFieldRefs = () => {
  const context = useContext(FieldRefsContext);
  if (!context) {
    throw new Error("useFieldRefs must be used within a FieldRefsProvider");
  }
  return context;
};
